import {
  INICIO_SESION_ERROR,
  CERRAR_SESION,
  AUTENTIFICACION404,
  CLEAR_SESION_ERROR,
} from "../types/index";

const initialState = {
  cargando: false,
  error: "",
  autenticado: window.localStorage.getItem("accessToken") ? true : false,
  accessToken: "",
  error401: false,
  usuario:
    window.localStorage.getItem("UseData") &&
    JSON.parse(window.localStorage.getItem("UseData")),
  nombre:
    window.localStorage.getItem("UseData") &&
    JSON.parse(window.localStorage.getItem("UseData")).nombre,
  mensaje: {
    show: false,
    gAuth: false,
    login: true,
    otp: { show: false, otp: [] },
  },
};
// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case "MANAGER_SESION":
      // tokenAuth(action.payload.token);
      window.localStorage.setItem("umname", action.payload.nombre);
      window.localStorage.setItem(
        "UseData",
        JSON.stringify(action.payload)
      );
      window.localStorage.setItem(
        "accessToken",
        action.payload.accessToken
      );
      window.localStorage.setItem(
        "refreshToken",
        action.payload.refreshToken
      );
      return {
        ...state,
        accessToken: action.payload.accessToken,
        cargando: false,
        autenticado: true,
        error401: false,
        usuario: action.payload,
        nombre: action.payload.nombre,
      };
    case "CERRAR_SESION_MANAGER":
      window.localStorage.removeItem("accessToken");
      window.localStorage.removeItem("refreshToken");
      window.localStorage.removeItem("UseData");
      window.localStorage.removeItem("umname");

      return {
        ...state,
        autenticado: false,
        cargando: false,
      };
    case AUTENTIFICACION404:
      window.localStorage.removeItem("accessToken");
      window.localStorage.removeItem("refreshToken");
      return {
        ...state,
        error401: false,
        autenticado: false,
      };
    case INICIO_SESION_ERROR:
      return {
        ...state,
        error: true,
        cargando: false,
        mensaje: action.payload,
      };
    case CLEAR_SESION_ERROR:
      return {
        ...state,
        error: false,
        cargando: false,
        mensaje: {
          ...state.mensaje,
          show: false,
          login: true,
        },
      };

    default:
      return state;
  }
}
